/* eslint-disable camelcase */
/* Reason: keys in mapping are used as a string prop in FeedbackIcon */

import {
  AlternateBuddyScoreMap,
  BuddyScoreMap,
  DislikeAlternateBuddyIcon,
  DislikeBuddyIcon,
  HateAlternateBuddyIcon,
  HateBuddyIcon,
  LikeAlternateBuddyIcon,
  LikeBuddyIcon,
  LoveAlternateBuddyIcon,
  LoveBuddyIcon,
  NeutralAlternateBuddyIcon,
  NeutralBuddyIcon,
} from './icons/BuddyIcon';
import {
  DislikeEmojiIcon,
  EmojiScoreMap,
  HateEmojiIcon,
  LikeEmojiIcon,
  LoveEmojiIcon,
  NeutralEmojiIcon,
} from './icons/EmojiIcon';

export const IconMapping = {
  hate_emoji: HateEmojiIcon,
  dislike_emoji: DislikeEmojiIcon,
  neutral_emoji: NeutralEmojiIcon,
  like_emoji: LikeEmojiIcon,
  love_emoji: LoveEmojiIcon,
  hate_buddy: HateBuddyIcon,
  dislike_buddy: DislikeBuddyIcon,
  neutral_buddy: NeutralBuddyIcon,
  like_buddy: LikeBuddyIcon,
  love_buddy: LoveBuddyIcon,
  hate_buddy_alternate: HateAlternateBuddyIcon,
  dislike_buddy_alternate: DislikeAlternateBuddyIcon,
  neutral_buddy_alternate: NeutralAlternateBuddyIcon,
  like_buddy_alternate: LikeAlternateBuddyIcon,
  love_buddy_alternate: LoveAlternateBuddyIcon,
};

export type BasicIconName = keyof typeof IconMapping;

export const ScoreIconMapping = {
  emoji: EmojiScoreMap,
  buddy: BuddyScoreMap,
  alternateBuddy: AlternateBuddyScoreMap,
};

export type ScoreIconName = keyof typeof ScoreIconMapping;
